module.exports = __webpack_public_path__ + "img/nu.1eea9c1.svg";